import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "pl-4 flex align-middle"
}
const _hoisted_2 = { class: "h-6 inline-block w-6 animate-spin" }

import { ref } from 'vue';
import { RefreshIcon } from '@heroicons/vue/outline';
import { Brand } from '../../services/integration/enums';
import { injectStrict } from '@/plugins/vueServiceContainerPlugin';
import { BrandServiceInterface } from '@/services/brand/brandServiceInterface';


export default /*@__PURE__*/_defineComponent({
  __name: 'AsyncButton',
  emits: ["onClick"],
  setup(__props, { emit: __emit }) {

const brandService = injectStrict<BrandServiceInterface>('BrandServiceInterface');

const loading = ref(false);

const emit = __emit;

const finishOnClick = () => {
  loading.value = false;
};

const onClick = async () => {
  // Don't run handler if the button is already handling something.
  if (loading.value) {
    return;
  }

  loading.value = true;
  await emit('onClick', finishOnClick);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    onClick: onClick,
    type: "submit",
    class: _normalizeClass([_unref(brandService).getName() === _unref(Brand).HIS ? 'font-gotham-bold shadow-sm transition duration-250 w-full lg:w-auto flex items-center justify-center px-6 py-4 text-base md:text-md rounded-lg text-brand-button-text bg-brand-button hover:bg-brand-button-hover md:text-lg md:px-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-brand-accent': 'transition duration-250 rounded-full hover:bg-white hover:border-solid hover:border-black bg-transparent bg-gradient-to-tr from-brand-primary-light to-brand-primary-dark py-3 px-6 shadow-md text-center font-poppins text-black border-none text-lg w-auto cursor-pointer', ""])
  }, [
    _renderSlot(_ctx.$slots, "default"),
    (loading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_unref(RefreshIcon))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})